import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const handleCleanupDrafts = async (onOk?: () => void) => {
  try {
    const response = await deleteWithCSRF(`${envApiUrl}/mydays/cleanup-drafts`);
    console.log('Cleanup drafts: response: ', response);
    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('handleCleanupDrafts error: ', err.response?.data?.message, err);
  }
};
